// client/src/pages/BoderStatic.jsx
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

const UNITS = [
  // Rediger fritt – dette er KUN statisk data.
  { id: "B1",  name: "Bod 1",  size: "24 m³",   price: 3000, period: "per mnd", status: "utleid",  img: "/icons/boder.jpg" },
  { id: "B8",  name: "Bod 8",  size: "11 m³",   price: 1100, period: "per mnd", status: "utleid",  img: "/icons/boder.jpg" },
  { id: "B9",  name: "Bod 9",  size: "7 m³",  price: 800,  period: "per mnd", status: "ledig",  img: "/icons/boder.jpg" },
  { id: "B10", name: "Bod 10", size: "8 m³",    price: 900,  period: "per mnd", status: "utleid",  img: "/icons/boder.jpg" },
  { id: "B11", name: "Bod 11", size: "11 m³", price: 1100, period: "per mnd", status: "ledig",  img: "/icons/boder.jpg" },
  { id: "B13", name: "Bod 13", size: "29 m³", price: 2200, period: "per mnd", status: "ledig", img: "/icons/boder.jpg" },
  { id: "B15", name: "Bod 15", size: "14 m³",   price: 1200, period: "per mnd", status: "utleid", img: "/icons/boder.jpg" },
  { id: "B16", name: "Bod 16", size: "10,2 m³",   price: 1000,  period: "per mnd", status: "utleid",  img: "/icons/boder.jpg" },
  { id: "B17", name: "Bod 17", size: "15 m³",   price: 500,  period: "per mnd", status: "utleid", img: "/icons/boder.jpg" },
];

const fmt = (n) => Number(n || 0).toLocaleString("no-NO");

export default function BoderStatic() {
  const stats = useMemo(() => {
    const ledig = UNITS.filter(u => u.status === "ledig").length;
    const utleid = UNITS.filter(u => u.status === "utleid").length;
    return { ledig, utleid, total: UNITS.length };
  }, []);

  return (
    <div className="max-w-screen-xl mx-auto p-6 space-y-10">
      {/* Tilbake-lenke (samme stil som GroupPage) */}
      <div className="w-full">
        <Link to="/" className="text-blue-600 hover:underline mb-4 inline-block">
          ← Tilbake til kategorier
        </Link>
      </div>

      {/* Hero / intro */}
      <section className="rounded-2xl overflow-hidden shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-2">
          {/* bevisst tom grid for evt. hero-bilder senere */}
        </div>
        <div className="bg-blue-50 px-6 py-5">
          <h1 className="text-3xl font-bold text-[#000099]">Boder til leie</h1>
          <p className="mt-2 text-gray-700">
            Vi tilbyr boder i flere størrelser, med alarm i oppvarmet lokale. Her ser du fast pris per måned og om en bod er ledig eller utleid.
            Kontakt oss for reservasjon eller visning.
          </p>
          <div className="mt-3 text-sm text-gray-600">
            Status nå: <span className="font-semibold text-green-700">{stats.ledig} ledig</span> •{" "}
            <span className="font-semibold text-red-700">{stats.utleid} utleid</span> • {stats.total} totalt
          </div>
        </div>
      </section>

      {/* Kort-grid */}
      <section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {UNITS.map(u => (
            <div key={u.id} className="rounded-2xl bg-white shadow hover:shadow-md transition overflow-hidden">
              {u.img ? (
                <img src={u.img} alt={u.name} className="w-full h-40 object-cover" />
              ) : (
                <div className="w-full h-40 bg-gray-100 flex items-center justify-center text-gray-400">Ingen bilde</div>
              )}
              <div className="p-4 space-y-2">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-lg">{u.name}</h3>
                  <span
                    className={`text-xs px-2 py-1 rounded ${
                      u.status === "ledig" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                    }`}
                  >
                    {u.status === "ledig" ? "Ledig" : "Utleid"}
                  </span>
                </div>
                <div className="text-sm text-gray-600">Størrelse: {u.size}</div>
                <div className="font-semibold">
                  Pris: {fmt(u.price)} kr <span className="text-sm text-gray-500">({u.period})</span>
                </div>
                <div className="pt-2">
                  <Link
                    to="/contact"
                    className="inline-block bg-[#000099] text-white px-4 py-2 rounded hover:bg-blue-900 transition"
                  >
                    Kontakt oss
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Tabelloversikt */}
      <section className="bg-white rounded-2xl shadow overflow-hidden">
        <div className="px-4 py-3 bg-blue-50 font-semibold text-[#000099]">Komplett oversikt</div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left px-4 py-2">Bod</th>
                <th className="text-left px-4 py-2">Størrelse</th>
                <th className="text-right px-4 py-2">Pris</th>
                <th className="text-left px-4 py-2">Status</th>
                <th className="text-right px-4 py-2">Handling</th>
              </tr>
            </thead>
            <tbody>
              {UNITS.map(u => (
                <tr key={u.id} className="border-t">
                  <td className="px-4 py-2">{u.name}</td>
                  <td className="px-4 py-2">{u.size}</td>
                  <td className="px-4 py-2 text-right">{fmt(u.price)} kr {u.period ? `(${u.period})` : ""}</td>
                  <td className="px-4 py-2">
                    {u.status === "ledig" ? (
                      <span className="text-green-700">Ledig</span>
                    ) : (
                      <span className="text-red-700">Utleid</span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-right">
                    <Link to="/contact" className="text-[#000099] hover:underline">
                      Kontakt oss →
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
